import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferBadge: Partial<Record<OfferKindEnum, string>> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: 'Extra {{percentageAmount}}% Rabatt',
  [OfferKindEnum.PercentageOffByProducts]: 'Extra {{percentageAmount}}% Rabatt',
  [OfferKindEnum.AmountOffByProducts]: 'Extra {{amount}} Rabatt',
  [OfferKindEnum.Bogo]: '1 kaufen, 1 gratis',
  [OfferKindEnum.BogoHalfPrice]: '1 kaufen, das zweite zum halben Preis!',
  [OfferKindEnum.FreeItemByProducts]: 'Gratisartikel',
  [OfferKindEnum.FreeItemByMinSpendValue]: 'Gratisartikel',
};

export default OfferBadge;
